import { api } from '../config'

export const USER_URL = {
  login: `${api.withAPI}/auth/admin`,
  get_user: `${api.withAPI}/admin/profile`,
  forgot_password: `${api.withAPI}/auth/forgot-password`,
  change_password: `${api.withAPI}/auth/change-password`,
}
